import { Box, Tab, TabPanel, Container, styled } from '@grupoboticario/flora-react';

export const styles = {
  TabListWrapper: styled(Box, {
    background: '$backgroundPrimary',
    paddingTop: '$3',
    marginBottom: '$10',
  }),

  Tab: styled(Tab, {
    width: '50%',
    '@tablet': {
      width: 'calc($17 * 3)',
    },
  }),

  TabPanel: styled(TabPanel, {
    padding: '0',
  }),
  Container: styled(Container, {
    padding: '0',
  }),
};

export default styles;
